import packageJson from "../package.json";

export const basePath = packageJson.homepage || "";
